// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"b6fc4704","456":"ff1c869e","656":"72f99ffb","756":"d6d195f5","968":"5e36a7db"}[chunkId] + ".chunk.js";
};